export enum labelsEnum {
  ACCOUNT_EDIT = 'Editar cálculo',
  SEND = 'Enviar',
  BACK = 'Voltar',
  CANCEL = 'Cancelar',
  NEXT = 'Próximo',
  FINISH = 'Concluir',
  USER_DELETE = 'Excluir usuário',
  NAME = 'Nome',
  ACTIONS = 'Ações',
  OPTIONS = 'Opções',
  LAST_NAME = 'Sobrenome',
  ADD = 'Adicionar',
  RELOAD = 'Recarregar',
  CALC_DATA = 'Dados do cálculo',
  UPDATE = 'Atualizar',
  TO = 'Até',
  UPDATE_TO = `${UPDATE} ${TO}`,
  SELECT_CALC_TYPE = 'Selecionar o tipo do cálculo',
  APPLICATION_ART_ADD = `${ADD} Aplicação de art.`,
  ART_TOTAL = 'Total do artigo',
  FEE_TOTAL = 'Total dos honorários',
  EXPENSE_TOTAL = 'Total das despesas',
  CALC_NAME = 'Nome do cálculo',
  MONTHLY_VARIATION_GRAPH = 'Gráfico de variação mensal (%)',
  MONETARY_CORRECTION = 'Correção Monetária',
  NEW_USER = 'Novo Usuário',
  EMAIL = 'E-Mail',
  EMAIL_PLACEHOLDER = `Digite seu ${EMAIL}`,
  SEND_EMAIL_ERROR = `Ocorreu um erro ao enviar o ${EMAIL}!`,
  PASSWORD = 'Senha',
  EDIT = 'Editar',
  RECOVERY = 'Recuperar',
  FROM = 'De',
  USER_EDIT = `${EDIT} usuário`,
  USER_RECOVERY = `${RECOVERY} usuário`,
  DELETE = 'Remover',
  ACCOUNT_DELETE = `${DELETE} cálculo`,
  OPEN = 'Abrir',
  CLOSE = 'Fechar',
  DUPLICATE = 'Duplicar',
  ACCOUNT_DUPLICATE = `${DUPLICATE} cálculo`,
  COST_CENTER_DELETE = `${DELETE} centro de custo`,
  COST_CENTER_EDIT = 'Editar centro de custo',
  COST_CENTER = 'Centro de custo',
  PROFILE = 'Perfil',
  LICENSE = 'Licença',
  PRO_RATA_LAW = 'Lei 14.905 (Taxa Legal)',
  PURGES = 'Expurgos',
  RECORD = 'Autos',
  COURT = 'Vara',
  DEFENDANTS = 'Réu',
  OBSERVATION = 'Observação',
  INDEX = 'Índice',
  FORMULA = 'Fórmula',
  DEFLATION = 'Deflação',
  CALC = 'Cálculo',
  TO_ENTER = 'Entrar',
  COST_CENTER_TOTAL = 'Total de centro de custos',
  AUTHOR_TOTAL = 'Total do autor',
  COST_CENTER_NEW = 'Novo centro de custo',
  COST_CENTER_UPDATE = 'Atualizar centro de custo',
  DESCRIPTION = 'Descrição',
  DATE = 'Data',
  TYPE = 'Tipo',
  UNITY = 'Unidade',
  TAX = 'Taxa',
  PERIODICITY = 'Periodicidade',
  PERIODICITY_TAX = `${PERIODICITY}/${TAX}`,
  OCCURRENCE = 'ocorrência',
  OCCURRENCE_ADD = `${ADD} ${OCCURRENCE}`,
  PERIOD = 'Período',
  INTEREST_FINE = 'Juros/Multa',
  INTEREST_FINE_ADD = `${ADD} ${INTEREST_FINE}`,
  VALUE_PERCENT = 'Valor/Percentual',
  DATE_START = 'Data inicial',
  DATE_END = 'Data final',
  VALUE = 'Valor',
  CORRIGIDO = 'Corrigido',
  DEADLINE = 'Prazo',
  SHORTAGE = 'Carência',
  CAPITAL = 'Capital',
  INTEREST_TAX = 'Taxa de Juros',
  AMOUNT = 'Montante',
  PURCHASE_PRICE = 'Valor de compra',
  PURCHASE_VALUE = 'Valor da prestação',
  INPUT_VALUE = 'Valor de entrada',
  PURCHASE_NUMBER = 'Número da prestação',
  INTEREST = 'Juros',
  DUPLICATE_INTEREST = `${DUPLICATE} ${INTEREST}`,
  GENERAGE_INSTALLMENT = 'Gerar Parcelas',
  AMORTIZATION = 'Amortização',
  CORRECTION = 'Correção',
  WITHOUT = `Sem`,
  WITH = `Com`,
  PURCHASE = 'Prestação',
  PURCHASE_TOTAL = 'Total das Prestações',
  INSTALLMENTS = 'Parcelas',
  FILTERS = 'Filtros',
  MAIN = 'Principal',
  INDICATOR = 'Indicador',
  BALANCE = 'Saldo',
  INTEREST_BALANCE = `${BALANCE} Juros`,
  TOTAL = 'Total',
  USERS_TOTAL = `${TOTAL} de usuários`,
  SELECT_INDEX = 'Selecione o(s) índice(s):',
  NOMENCLATURE_EDIT = 'Editar nomenclatura',
  CURRENT_ACCOUNT = 'Cálculos - Conta Corrente',
  AUTOMATED_CALC = 'Cálculos - Atualização Automatizada',
  FINANCIAL = 'Calculadora Financeira',
  CONVERTER = 'Conversor',
  APPLY_INTEREST_BALANCE = 'sobre o saldo dos juros',
  APPLY_FINE_BALANCE = 'sobre o saldo da multa',
  CONVERTER_MEASURE = 'Medidas',
  MEASURE = 'Medida',
  QUANTITY = 'Quantidade',
  CONVERTER_INDEX = 'Indices',
  INDICATORS = 'Indicadores',
  RETROACTOR = 'Retroator',
  FINANCING = 'Finaciamento',
  FINANCING_CREDIT_PURCHASE = 'Compras à Prazo',
  FINANCING_AMORTIZATION = AMORTIZATION,
  FINANCING_CAPITALIZATION = 'Capitalização',
  USERS = 'Gestão de Usuários',
  NOMENCLATURES = 'Nomenclaturas',
  AUTHOR = 'Autor',
  AUTHOR_ADD = `${ADD} ${AUTHOR}`,
  INFOS = 'Informações',
  CONFIG = 'Configurações',
  INTEREST_FINE_CONFIG = `${ADD} ${CONFIG}`,
  FEE = 'Honorários',
  QUANTIA_CERTA = 'por quantia certa',
  FINE = 'Multa',
  EXPENSE = 'Diversos',
  EXPENSE_SECTION = 'Despesas',
  EXPENSE_ADD = `${ADD} ${EXPENSE_SECTION}`,
  PAYMENT = 'Pagamentos',
  CALC_TOTAL = 'Total do cálculo',
  CURRENT_ACCOUNT_TOTAL = 'Total do cálculo de conta corrente',
  AUTOMATED_CALC_TOTAL = 'Total do cálculo de atualização automatizada',
  MEM_CALC = 'Memória de Cálculo',
}
